import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { startCase } from 'lodash';
import { Page } from 'components';
import { AuthContext } from 'contexts';
import { MLSStaffMenuOptionsType } from 'components/SideMenu/MenuSection/types';
import MLSStaffRightHeader from './MLSStaffRightHeader';
import MLSStaffBrokeragesTable from './MLSStaffBrokeragesPage/MLSStaffBrokeragesTable';
import { MLSStaffContextProvider } from './MLSStaffContext';
import MLSStaffUsersTable from './MLSStaffUsersPage/MLSStaffUsersTable';
import MLSStaffLockboxesTable from './MLSStaffLockboxesPage/MLSStaffLockboxesTable';

const MLSStaffPage: React.FC<{ type: MLSStaffMenuOptionsType }> = ({
  type,
}) => {
  const { auth } = useContext(AuthContext);
  if (auth?.org?.type !== 'mlsStaff') {
    return <Redirect to="/listing/list/brokerage/0" />;
  }

  let child: React.ReactNode = null;
  switch (type) {
    case 'brokerages':
      child = <MLSStaffBrokeragesTable />;
      break;
    case 'users':
      child = <MLSStaffUsersTable />;
      break;
    case 'lockboxes':
      child = <MLSStaffLockboxesTable />;
      break;
    default:
      break;
  }

  return (
    <MLSStaffContextProvider>
      <Page
        type="filled"
        title={startCase(type)}
        fillScreenHeight
        headerExtra={<MLSStaffRightHeader />}
      >
        {child}
      </Page>
    </MLSStaffContextProvider>
  );
};

export default MLSStaffPage;
